export default __webpack_public_path__ + "static/media/pending-clock.35e04b92.svg";